export default function() {
  return this._root;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-quadtree/src/root.js
// module id = null
// module chunks = 